<template>
    <div class="portlet light bordered">
        <div class="portlet-title">
            <div class="caption">
                <i class="icon-equalizer font-red-sunglo"></i>
                <span class="caption-subject font-red-sunglo bold uppercase">
                        {{ 'purchase_order.purchase_orders' | trans }}
                    </span>
                <span class="caption-helper">{{ 'purchase_order.panel' | trans }}</span>
            </div>
        </div>
        <view-loader :loading="!!loading">
            <purchase-order-materials-search
                    :disabled="!!disabled"
                    @request="onSearchRequest"
                    @response="onSearchResponse"
            />
            <purchase-order-materials
                    v-if="wasSearched && items.length"
                    :items="items"
                    :disabled="!!disabled"
                    :is-dev="isDev"
                    :is-forecast="isForecast"
                    @request="loading++"
                    @response="loading--"
                    @disable="onDisable"
            />
            <div v-else-if="wasSearched && !loading" class="alert alert-info">
                {{ 'grid.no_data_message' | trans}}
            </div>
            <template #label>
                <h2>{{ 'please_wait' | trans }}...</h2>
            </template>
        </view-loader>
    </div>
</template>

<script>
import PurchaseOrderMaterialsSearch from '@js/forms/purchaseOrderMaterials/Search.vue'
import PurchaseOrderMaterials from '@js/forms/purchaseOrderMaterials/Materials.vue'
import ViewLoader from '@component/ViewLoader.vue'

export default {
  name: 'PurchaseOrderMaterialsForm',
  components: {
    PurchaseOrderMaterials,
    PurchaseOrderMaterialsSearch,
    ViewLoader
  },
  props: {
    isDev: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: 0,
      items: [],
      isForecast: false,
      wasSearched: false,
      disabled: 0,
    }
  },
  methods: {
    onSearchRequest() {
      this.loading++
      this.items = []
      this.isForecast = false
    },
    onSearchResponse(result) {
      if (result) {
        this.items = result.items
        this.isForecast = result.isForecast
        this.wasSearched = true
      }

      this.loading--
    },
    onDisable(value) {
      value ? this.disabled++ : this.disabled--
    }
  }
}
</script>

<style>
#purchase_order_materials_form .multiselect__tags {
    border: 1px solid #ccc;
    border-radius: 4px;
    min-height: 34px;
    padding-top: 4px;
    background: transparent;
}

#purchase_order_materials_form .multiselect__tag {
    margin-bottom: 1px;
}

#purchase_order_materials_form .multiselect__single {
    background: transparent;
}

#purchase_order_materials_form .multiselect__input::placeholder,
#purchase_order_materials_form .multiselect__single::placeholder,
#purchase_order_materials_form input[name="datetime"]::placeholder {
    color: #ccc;
}
</style>
